import {customGeopointBasicTypes, customGeopointProhibitionTypes, customGeopointType} from '../constants/custom-geopoint.constants';
import {MimeTypeService} from '../mime-type.service';
import * as L from 'leaflet';
import {divIcon} from 'leaflet';
import {GeopointTypeModel} from '../models/geopoint-type.model';

export class GeopointHelper {
  static createIconHtml(data: GeopointTypeModel, mimeTypeService: MimeTypeService): string | null {
    if (!data || !data.type) {
      return null;
    }

    if (!data.image) {
      const type = customGeopointType[data.type.toLowerCase()];
      return type
        ? `<div class="icon-geopoint-type ${type}"></div>`
        : null;
    }

    const mime = mimeTypeService.getImageMimeType(data.image);
    const src = `data:${mime};base64,${data.image}`;

    return `<img class="geopoint-type-icon" src="${src}" alt="icon">`;
  }

  static createIconForGeopointType(geopointType: GeopointTypeModel, mimeTypeService: MimeTypeService) {
    if (!geopointType.image) {
      const basicType = customGeopointBasicTypes[geopointType.type.toLowerCase()];
      const prohibitionType = customGeopointProhibitionTypes[geopointType.type.toLowerCase()];
      if (prohibitionType) {
        return divIcon({
          className: 'icon-geopoint-type_34 ' + prohibitionType,
          iconSize: [34, 34],
          iconAnchor: [17, 17],
          shadowSize: [0, 0]
        });
      }
      if (basicType) {
        return divIcon({
          className: 'icon-geopoint-type ' + basicType,
          iconSize: [24, 24],
          iconAnchor: [12, 12],
          shadowSize: [0, 0]
        });
      }
    } else {
      const mimetype = 'data:' + mimeTypeService.getImageMimeType(geopointType.image) +
        ';base64,' + geopointType.image;
      return L.icon({
        iconUrl: mimetype,
        iconSize: [24, 24],
        iconAnchor: [12, 12],
        shadowSize: [0, 0]
      });
    }
  }
}

